import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class Section {
    constructor() {
        this.init();
    }

    init() {
        this.setCurrent();
    }

    setCurrent() {
        const container = document.querySelector(".js-contents");
        const section = document.querySelectorAll(".js-section");

        section.forEach(el => {
            const changeCurrent = () => {
                const currentSec = el.getAttribute("data-section");
                document.body.setAttribute("data-currentsec", currentSec);
            };

            ScrollTrigger.create({
                trigger: el,
                scroller: container,
                start: "top 40%",
                end: "bottom 60%",
                // markers: true,
                onEnter: () => {
                    changeCurrent();
                },
                onEnterBack: () => {
                    changeCurrent();
                },
            });
        });

        window.onresize = () => {
            ScrollTrigger.refresh();
        };
    }

    refresh() {
        ScrollTrigger.refresh();
    }
}
